/* import __COLOCATED_TEMPLATE__ from './form-blocks.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class RequestInformationFormBlocks extends Component {
  @service session;

  @action
  onInput({ target }) {
    this.args.onInputChange?.({ target });
  }

  @action
  onSubmitClick() {
    this.args.nextStep?.('desktop', this.args.stripeElements);
  }

  @action
  onMobileSubmitClick() {
    this.args.nextStep?.('', this.args.stripeElements);
  }
}
